import { useState } from "react";
import { toast } from "sonner";
import { adminApi, errorMessage } from "@/api";

const inputCls = "w-full h-10 px-3 bg-white border border-slate-300 rounded-md text-sm focus:border-emerald-600 outline-none";
const labelCls = "text-sm font-semibold text-slate-700 mb-1.5 block";

export default function MiCuenta() {
  const [form, setForm] = useState({ actual: "", nueva: "", repite: "" });

  const save = async () => {
    if (form.nueva !== form.repite) {
      toast.error("Las contrasenas nuevas no coinciden");
      return;
    }
    try {
      await adminApi.post("/auth/change-password", { password_actual: form.actual, password_nueva: form.nueva });
      toast.success("Contrasena actualizada");
      setForm({ actual: "", nueva: "", repite: "" });
    } catch (e) {
      toast.error(errorMessage(e));
    }
  };

  return (
    <div className="max-w-md" data-testid="mi-cuenta">
      <h1 className="font-heading text-2xl font-bold text-slate-900 mb-6">Cambiar mi contrasena</h1>
      <div className="bg-white border border-slate-200 rounded-lg p-5 space-y-4">
        <div><label className={labelCls}>Contrasena actual</label><input data-testid="pass-actual" type="password" className={inputCls} value={form.actual} onChange={(e) => setForm({ ...form, actual: e.target.value })} /></div>
        <div><label className={labelCls}>Nueva contrasena (minimo 8 caracteres)</label><input data-testid="pass-nueva" type="password" className={inputCls} value={form.nueva} onChange={(e) => setForm({ ...form, nueva: e.target.value })} /></div>
        <div><label className={labelCls}>Repetir nueva contrasena</label><input data-testid="pass-repite" type="password" className={inputCls} value={form.repite} onChange={(e) => setForm({ ...form, repite: e.target.value })} /></div>
        <button data-testid="pass-save-button" onClick={save} disabled={!form.actual || form.nueva.length < 8}
          className="h-10 px-5 rounded-[10px] bg-[#1C1C1E] hover:bg-zinc-800 disabled:bg-slate-300 text-white text-sm font-semibold">Actualizar contrasena</button>
      </div>
    </div>
  );
}
